

"use client";
import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  CircularProgress,
  Alert,
  Snackbar,
  Tooltip,
  IconButton,
  Modal,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import GoogleCaptchaWrapper from "./GoogleCaptchaWrapper";
import GoogleSlotPicker from "@/components/GoogleSlotPicker";
// ── Arabic numerals helper ────────────────────────────────────────────────────
const toArabicNumerals = (str) => str.replace(/[0-9]/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
const RECRUITER_EMAIL = "abdulhannan1200ah@gmail.com"; // jis recruiter ka calendar connect kiya

const checkItems = [
  "bookDemoSection.check1",
  "bookDemoSection.check2",
  "bookDemoSection.check3",
  "bookDemoSection.check4",
];

const stats = [
  {
    valueKey: "bookDemoSection.stat1.value",
    labelKey: "bookDemoSection.stat1.label",
  },
  {
    valueKey: "bookDemoSection.stat2.value",
    labelKey: "bookDemoSection.stat2.label",
  },
  {
    valueKey: "bookDemoSection.stat3.value",
    labelKey: "bookDemoSection.stat3.label",
  },
];

// ── Shared input sx ───────────────────────────────────────────────────────────
const countryCodes = [
  { value: "+966", flag: "🇸🇦" },
  { value: "+971", flag: "🇦🇪" },
  { value: "+1", flag: "🇺🇸" },
  { value: "+44", flag: "🇬🇧" },
  { value: "+91", flag: "🇮🇳" },
  { value: "+61", flag: "🇦🇺" },
  { value: "+49", flag: "🇩🇪" },
  { value: "+33", flag: "🇫🇷" },
  { value: "+81", flag: "🇯🇵" },
  { value: "+86", flag: "🇨🇳" },
  { value: "+55", flag: "🇧🇷" },
  { value: "+52", flag: "🇲🇽" },
  { value: "+92", flag: "🇵🇰" },
  { value: "+31", flag: "🇳🇱" },
  { value: "+34", flag: "🇪🇸" },
  { value: "+39", flag: "🇮🇹" },
  { value: "+46", flag: "🇸🇪" },
  { value: "+27", flag: "🇿🇦" },
  { value: "+65", flag: "🇸🇬" },
  { value: "+60", flag: "🇲🇾" },
  { value: "+66", flag: "🇹🇭" },
  { value: "+20", flag: "🇪🇬" },
  { value: "+90", flag: "🇹🇷" },
  { value: "+7", flag: "🇷🇺" },
  { value: "+62", flag: "🇮🇩" },
  { value: "+63", flag: "🇵🇭" },
  { value: "+82", flag: "🇰🇷" },
  { value: "+880", flag: "🇧🇩" },
  { value: "+94", flag: "🇱🇰" },
  { value: "+977", flag: "🇳🇵" },
  { value: "+964", flag: "🇮🇶" },
  { value: "+962", flag: "🇯🇴" },
  { value: "+961", flag: "🇱🇧" },
  { value: "+965", flag: "🇰🇼" },
  { value: "+974", flag: "🇶🇦" },
  { value: "+973", flag: "🇧🇭" },
  { value: "+968", flag: "🇴🇲" },
  { value: "+212", flag: "🇲🇦" },
  { value: "+213", flag: "🇩🇿" },
  { value: "+216", flag: "🇹🇳" },
  { value: "+218", flag: "🇱🇾" },
  { value: "+234", flag: "🇳🇬" },
  { value: "+254", flag: "🇰🇪" },
  { value: "+233", flag: "🇬🇭" },
  { value: "+256", flag: "🇺🇬" },
  { value: "+251", flag: "🇪🇹" },
  { value: "+225", flag: "🇨🇮" },
  { value: "+220", flag: "🇬🇲" },
  { value: "+353", flag: "🇮🇪" },
  { value: "+41", flag: "🇨🇭" },
  { value: "+43", flag: "🇦🇹" },
  { value: "+32", flag: "🇧🇪" },
  { value: "+351", flag: "🇵🇹" },
  { value: "+30", flag: "🇬🇷" },
  { value: "+48", flag: "🇵🇱" },
  { value: "+420", flag: "🇨🇿" },
  { value: "+36", flag: "🇭🇺" },
  { value: "+40", flag: "🇷🇴" },
  { value: "+380", flag: "🇺🇦" },
  { value: "+45", flag: "🇩🇰" },
  { value: "+47", flag: "🇳🇴" },
  { value: "+358", flag: "🇫🇮" },
  { value: "+372", flag: "🇪🇪" },
  { value: "+371", flag: "🇱🇻" },
  { value: "+370", flag: "🇱🇹" },
  { value: "+64", flag: "🇳🇿" },
  { value: "+972", flag: "🇮🇱" },
  { value: "+56", flag: "🇨🇱" },
  { value: "+57", flag: "🇨🇴" },
  { value: "+51", flag: "🇵🇪" },
  { value: "+54", flag: "🇦🇷" },
  { value: "+593", flag: "🇪🇨" },
  { value: "+58", flag: "🇻🇪" },
  { value: "+1", flag: "🇨🇦" },
  { value: "+852", flag: "🇭🇰" },
  { value: "+853", flag: "🇲🇴" },
  { value: "+886", flag: "🇹🇼" },
  { value: "+84", flag: "🇻🇳" },
  { value: "+95", flag: "🇲🇲" },
  { value: "+855", flag: "🇰🇭" },
  { value: "+856", flag: "🇱🇦" },
  { value: "+998", flag: "🇺🇿" },
  { value: "+7", flag: "🇰🇿" },
  { value: "+993", flag: "🇹🇲" },
  { value: "+996", flag: "🇰🇬" },
  { value: "+992", flag: "🇹🇯" },
  { value: "+93", flag: "🇦🇫" },
];
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    bgcolor: "rgba(255,255,255,0.9)",
    fontFamily: "var(--font-outfit), sans-serif",
    "& fieldset": { borderColor: "#9CA3AF" },
    "&:hover fieldset": { borderColor: "#9CA3AF" },
    "&.Mui-focused fieldset": { borderColor: "#9CA3AF", borderWidth: "1px" },
  },
  "& .MuiInputBase-input": {
    color: "#374151",
    fontFamily: "var(--font-outfit), sans-serif",
    padding: { xs: "8px 12px", sm: "9px 13px", md: "10px 14px" },
    fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.875rem" },
  },
  "& .MuiInputBase-input::placeholder": { color: "#9CA3AF", opacity: 1 },
};

// ── Field label helper ────────────────────────────────────────────────────────
const FieldLabel = ({ children, required, isArabic }) => (
  <Typography
    sx={{
      fontFamily: "var(--font-outfit), sans-serif",
      fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
      fontWeight: 500,
      color: "#374151",
      mb: 0.5,
      textAlign: isArabic ? "right" : "left",
    }}
  >
    {children}
    {required && (
      <Box component="span" sx={{ color: "#EF4444", ml: 0.3 }}>
        *
      </Box>
    )}
  </Typography>
);

// ── Checkbox option row ───────────────────────────────────────────────────────
const CheckOption = ({ label, checked, onChange, isArabic }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      mb: 1.5,
      flexDirection: isArabic ? "row" : "row",
    }}
  >
    <Checkbox
      checked={checked}
      onChange={onChange}
      sx={{
        color: "#FFB200",
        "&.Mui-checked": { color: "#FFB200" },
        p: 0.5,
        flexShrink: 0,
      }}
    />
    <Typography
      sx={{
        fontFamily: "var(--font-outfit), sans-serif",
        fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1rem" },
        color: "#374151",
        flex: 1,
        lineHeight: 1.5,
        wordBreak: "break-word",
        textAlign: isArabic ? "right" : "left",
      }}
    >
      {label}
    </Typography>
  </Box>
);

// ══════════════════════════════════════════════════════════════════════════════
// ── STEP ORDER (updated) ──────────────────────────────────────────────────────
// Step 1: Open roles (how many open roles are you hiring for?) — reCAPTCHA runs here
// Step 2: What's slowing down your hiring?
// Step 3: First name + Email
// Step 4: Phone number + Company website + Company name
// Step 5: Google Calendar booking
//
// NOTE: "Hear about us" and "Challenges" steps are currently NOT part of the
// flow — their JSX/validation blocks are commented out below instead of being
// deleted, in case they need to be brought back later.
// ── Generates a per-form-session id ───────────────────────────────────────────
// Since email is no longer collected on step 1 (it now lives on step 3), we
// can't rely on email to identify/upsert the same MongoDB document across the
// early steps (openRoles, hiringSlowdowns) the way the old flow did. Instead
// every save call carries this client-generated id, and the backend upserts
// on { submissionId, source } instead of { email, source }. Once email is
// collected (step 3) it's just saved as a normal field on that same document.
const generateSubmissionId = () =>
  typeof window !== "undefined" &&
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
    ? window.crypto.randomUUID()
    : `sub_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

// ══════════════════════════════════════════════════════════════════════════════
const BookDemoSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  // ── Multi-step state ──────────────────────────────────────────────────────
  const totalSteps = 5; // 4 form steps + 1 booking step

  const [currentStep, setCurrentStep] = useState(1);
  // Identifies this form session for the backend upsert (see
  // generateSubmissionId above) — regenerated every time the form resets.
  const [submissionId, setSubmissionId] = useState(() => generateSubmissionId());
  const [captchaError, setCaptchaError] = useState("");
  const [emailVerifying, setEmailVerifying] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: "", text: "" });

  // ── Popup-modal state (opened instantly from navbar "Book Demo" button) ───
  const [formModalOpen, setFormModalOpen] = useState(false);

  useEffect(() => {
    const openModal = () => setFormModalOpen(true);
    window.addEventListener("open-book-demo-modal", openModal);
    return () => window.removeEventListener("open-book-demo-modal", openModal);
  }, []);

  // ── When the popup modal closes, reset the form back to step 1 (blank)
  // so reopening it always starts fresh instead of resuming/pre-filled. ───
  const prevFormModalOpenRef = useRef(formModalOpen);
  useEffect(() => {
    if (prevFormModalOpenRef.current && !formModalOpen) {
      setCurrentStep(1);
      setFormData({
        firstName: "",
        email: "",
        companyWebsite: "",
        phoneCountryCode: "+966",
        phoneNumber: "",
        companyName: "",
        openRoles: "",
        hiringSlowdowns: [],
        hiringSlowdownsOther: "",
        hearAbout: "",
        hearAboutOther: "",
        challenges: "",
      });
      setErrors({});
      setShowHiringSlowdownsOther(false);
      setShowHearAboutOther(false);
      setCaptchaError("");
      setMeetingBooked(false);
      setMeetingDate(null);
      setMeetingTime(null);
      setSubmissionId(generateSubmissionId());
      bookingTrackedRef.current = false; // reset tracking guard on modal close/reset
    }
    prevFormModalOpenRef.current = formModalOpen;
  }, [formModalOpen]);

  // ── Booking state ──────────────────────────────────────────────────────
  const [meetingBooked, setMeetingBooked] = useState(false);
  const [meetingDate, setMeetingDate] = useState(null);
  const [meetingTime, setMeetingTime] = useState(null);
  const [showPickSlotHint, setShowPickSlotHint] = useState(false);
  const socketRef = useRef(null);
  const prevStepRef = useRef(1);
  const bookingTrackedRef = useRef(false); // prevents double dataLayer push

  // Single source of truth for the GTM dataLayer push, called from BOTH the
  // GoogleSlotPicker onBooked callback (fast path) and the socket
  // "booking_confirmed" listener (slower/fallback path), guarded so it only
  // ever fires once per booking.
  const pushBookingConfirmed = () => {
    if (bookingTrackedRef.current) return;
    bookingTrackedRef.current = true;
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "booking_confirmed" });
    }
  };

  const [showHiringSlowdownsOther, setShowHiringSlowdownsOther] =
    useState(false);
  const [showHearAboutOther, setShowHearAboutOther] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    companyWebsite: "",
    phoneCountryCode: "+966",
    phoneNumber: "",
    companyName: "",
    openRoles: "",
    hiringSlowdowns: [],
    hiringSlowdownsOther: "",
    hearAbout: "",
    hearAboutOther: "",
    challenges: "",
  });

  const [errors, setErrors] = useState({});

  // ── Country code search (dropdown search field) ───────────────────────────
  const [countrySearch, setCountrySearch] = useState("");
  const filteredCountryCodes = countryCodes.filter((c) =>
    c.value.replace("+", "").includes(countrySearch.replace("+", "").trim()),
  );

  // ── Reset the "pick a slot" hint when entering the booking step (step 5) ──
  useEffect(() => {
    if (currentStep === 5 && prevStepRef.current !== 5) {
      setShowPickSlotHint(false);
    }
    prevStepRef.current = currentStep;
  }, [currentStep]);

  // ── Auto-hide the "pick a slot" hint banner ───────────────────────────────
  useEffect(() => {
    if (!showPickSlotHint) return;
    const timer = setTimeout(() => setShowPickSlotHint(false), 3000);
    return () => clearTimeout(timer);
  }, [showPickSlotHint]);

  // ── Socket.io — listen for booking_confirmed on the booking step ─────────
  useEffect(() => {
    if (currentStep !== 5 || meetingBooked || !formData.email?.trim()) return;
    const email = formData.email.trim().toLowerCase();

    (async () => {
      const { io } = await import("socket.io-client");
      const origin =
        typeof window !== "undefined" ? window.location.origin : "";
      const socket = io(origin, { path: "/socket.io" });
      socketRef.current = socket;

      const joinRoom = () => socket.emit("join_booking_room", { email });
      socket.on("connect", joinRoom);
      socket.on("connect_error", (err) =>
        console.error("[BookDemo] Socket connect_error", err.message),
      );
      if (socket.connected) joinRoom();

      socket.on("booking_confirmed", (data) => {
        pushBookingConfirmed();

        setMeetingDate(data.startTime);
        setMeetingTime(data.endTime || data.startTime);
        setMeetingBooked(true);
        sendConfirmationEmail(
          data.startTime,
          data.endTime || data.startTime,
        ).catch(console.error);
      });
    })();

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [currentStep, meetingBooked, formData.email]);

  // ── Save firstName, email, phoneNumber to sessionStorage ─────────────────
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (formData.firstName) {
      sessionStorage.setItem("bookDemo_firstName", formData.firstName);
      console.log("sessionStorage key saved:", "bookDemo_firstName", "->", formData.firstName);
    }
  }, [formData.firstName]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (formData.email) {
      sessionStorage.setItem("bookDemo_email", formData.email);
      console.log("sessionStorage key saved:", "bookDemo_email", "->", formData.email);
    }
  }, [formData.email]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (formData.phoneNumber) {
      const fullPhone = `${formData.phoneCountryCode || ""} ${formData.phoneNumber}`.trim();
      sessionStorage.setItem("bookDemo_phoneNumber", fullPhone);
      console.log("sessionStorage key saved:", "bookDemo_phoneNumber", "->", fullPhone);
    }
  }, [formData.phoneNumber, formData.phoneCountryCode]);


  // ── Send confirmation email ───────────────────────────────────────────────
  const sendConfirmationEmail = async (date, time) => {
    try {
      const payload = {
        firstName: formData.firstName,
        email: formData.email,
        meetingDate: date || meetingDate,
        meetingTime: time || meetingTime,
        companyWebsite: formData.companyWebsite || undefined,
        language: i18n.language,
        submissionId,
      };
      const response = await fetch("/api/send-confirmation-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!data.success)
        console.error("Failed to send confirmation email:", data.message);
    } catch (error) {
      console.error("Error sending confirmation email:", error);
    }
  };

  // ── reCAPTCHA v3 (invisible) ──────────────────────────────────────────────
  // No widget to render — grecaptcha.execute() is called on demand (right
  // before submitting step 1) and silently returns a token in the background.
  const getRecaptchaToken = (action = "book_demo") =>
    new Promise((resolve, reject) => {
      if (typeof window === "undefined" || !window.grecaptcha) {
        reject(new Error("reCAPTCHA not loaded yet. Please try again."));
        return;
      }
      const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
      try {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(siteKey, { action })
            .then(resolve)
            .catch(() =>
              reject(new Error("reCAPTCHA verification failed. Please try again.")),
            );
        });
      } catch (e) {
        reject(new Error("reCAPTCHA verification failed. Please try again."));
      }
    });

  // ── Validation ────────────────────────────────────────────────────────────
  const validateStep = (step) => {
    const e = {};
    // Step 1: Open roles
    if (step === 1) {
      if (!formData.openRoles)
        e.openRoles = t("contactMain.validation.selectOne");
    }
    // Step 2: Hiring slowdowns
    if (step === 2) {
      if (formData.hiringSlowdowns.length === 0)
        e.hiringSlowdowns = t("contactMain.validation.selectOne");
      if (
        formData.hiringSlowdowns.includes("other") &&
        !formData.hiringSlowdownsOther.trim()
      )
        e.hiringSlowdownsOther = t("contactMain.validation.pleaseSpecify");
    }
    // Step 3: First name + Email
    if (step === 3) {
      if (!formData.firstName.trim())
        e.firstName = t("contactMain.validation.firstNameRequired");
      if (!formData.email.trim()) {
        e.email = t("contactMain.validation.emailRequired");
      } else if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/.test(
          formData.email.trim(),
        )
      ) {
        e.email = t("contactMain.validation.emailInvalid");
      } 
      // else if (
      //   /@(gmail|googlemail|yahoo|hotmail|outlook|live|icloud|aol|mail\.com|protonmail|zoho|yandex)\./i.test(
      //     formData.email.trim(),
      //   )
      // ) {
      //   e.email = t("contactMain.validation.emailWorkOnly");
      // }
    }
    // Step 4: Phone number + Company website + Company name
    if (step === 4) {
      const digits = (formData.phoneNumber || "").replace(/\D/g, "");
      if (!formData.phoneNumber?.trim())
        e.phoneNumber = t("contactMain.validation.phoneRequired");
      else if (digits.length < 10)
        e.phoneNumber = t("contactMain.validation.phoneInvalid");
      const site = (formData.companyWebsite || "").trim();
      const urlReg =
        /^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(\.[a-zA-Z]{2,})+(:\d+)?(\/.*)?$/i;
      if (!site) e.companyWebsite = t("contactMain.validation.websiteRequired");
      else if (!urlReg.test(site))
        e.companyWebsite = t("contactMain.validation.websiteInvalid");
      if (!formData.companyName.trim())
        e.companyName = "Company name is required";
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  // ── Change handler ────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      const arr = formData[name] || [];
      if (checked) {
        setFormData((p) => ({ ...p, [name]: [...arr, value] }));
        if (value === "other" && name === "hiringSlowdowns")
          setShowHiringSlowdownsOther(true);
      } else {
        setFormData((p) => ({ ...p, [name]: arr.filter((i) => i !== value) }));
        if (value === "other" && name === "hiringSlowdowns") {
          setShowHiringSlowdownsOther(false);
          setFormData((p) => ({ ...p, hiringSlowdownsOther: "" }));
        }
      }
    } else {
      let next = value;
      if (name === "phoneNumber")
        next = (value || "").replace(/\D/g, "").replace(/^0+/, "").slice(0, 15);
      setFormData((p) => ({ ...p, [name]: next }));
    }
    if (errors[name]) setErrors((p) => ({ ...p, [name]: "" }));
  };

  // ── Email verify (Reoon Power Mode via backend API) ──────────────────────
  const verifyEmail = async (email) => {
    try {
      setEmailVerifying(true);
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_NEST_BACKEND_URL}/email-verification/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        },
      );
      const json = await res.json();

      if (!res.ok || !json?.success || !json?.data) {
        return {
          valid: false,
          message:
            json?.data?.message ||
            json?.message ||
            "Email verification failed. Please try again.",
        };
      }

      const { isSafeToSend, message } = json.data;
      return {
        valid: !!isSafeToSend,
        message,
      };
    } catch {
      return {
        valid: false,
        message: "Email verification failed. Please try again.",
      };
    } finally {
      setEmailVerifying(false);
    }
  };
  // ── Save step to ads_collection ───────────────────────────────────────────
  const saveStep = async (step, recaptchaToken) => {
    setLoading(true);
    try {
      const payload = {
        step,
        source: "/recruitment-automation-software",
        submissionId,
         language: i18n.language,
        ...formData,
      };
      // Phone number is collected on step 4 now
      if (step === 4 && formData.phoneCountryCode && formData.phoneNumber) {
        const digits = (formData.phoneNumber || "")
          .replace(/\D/g, "")
          .replace(/^0+/, "");
        payload.phoneNumber = `${formData.phoneCountryCode} ${digits}`;
      }
      // reCAPTCHA token is generated on step 1 now
      if (step === 1) {
        if (!recaptchaToken) {
          setSubmitMessage({
            type: "error",
            text: t("contactMain.captchaRequired"),
          });
          setShowToast(true);
          setLoading(false);
          return false;
        }
        payload.token = recaptchaToken;
      }
      const res = await fetch("/api/save-ads-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok && data.success) return true;
      setSubmitMessage({
        type: "error",
        text: data.message || t("contactMain.saveFailed"),
      });
      setShowToast(true);
      return false;
    } catch {
      setSubmitMessage({ type: "error", text: t("contactMain.networkError") });
      setShowToast(true);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // ── Navigation ────────────────────────────────────────────────────────────
  const handleNext = async () => {
    if (currentStep === 5) return; // booking step

    if (!validateStep(currentStep)) return;

    // reCAPTCHA now runs on step 1 (open roles)
    let recaptchaToken;
    if (currentStep === 1) {
      try {
        recaptchaToken = await getRecaptchaToken("book_demo_step1");
        setCaptchaError("");
      } catch (err) {
        setCaptchaError(err.message || "reCAPTCHA verification failed. Please try again.");
        return;
      }
    }

    // Email verification now runs on step 3 (name + email)
    if (currentStep === 3) {
      const nb = await verifyEmail(formData.email.trim());
      if (!nb.valid) {
        setErrors((p) => ({ ...p, email: nb.message }));
        return;
      }
    }

    const saved = await saveStep(currentStep, recaptchaToken);
    if (!saved) return;

    if (currentStep === 4) {
      setCurrentStep(5);
      await saveStep(5);
      return;
    }

    setCurrentStep((p) => p + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((p) => p - 1);
      if (currentStep === 2) {
        setCaptchaError("");
      }
    }
  };

  // ── Step headline helper ──────────────────────────────────────────────────
  const StepHeadline = ({ children }) => (
    <Typography
      sx={{
        fontWeight: "bold",
        color: "#111827",
        fontFamily: "var(--font-plusjakarta), sans-serif",
        mb: 1.5,
        fontSize: { xs: "1rem", sm: "1.3rem", md: "1.4rem" },
        textAlign: isArabic ? "right" : "left",
        lineHeight: 1.3,
      }}
    >
      {children}
    </Typography>
  );

  // ── Reusable form card (used inline in the section AND inside the popup modal) ──
  // `isPopup` tells this render which "slot" it belongs to (inline vs the popup
  // modal). Both slots share the SAME currentStep/formData state, so without this
  // flag BOTH slots would try to mount the booking widget at the booking step
  // simultaneously. We only ever let the slot that matches the current
  // `formModalOpen` state actually render the GoogleSlotPicker widget.
  const renderFormCard = (isPopup = false) => (
    <Box sx={{ backgroundColor: "#fff", p: { xs: 0, sm: 1, md: 2 } }}>
      <Typography
        sx={{
          fontFamily: "var(--font-plusjakarta), sans-serif",
          fontWeight: 800,
          fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
          color: "#0f172a",
          mb: { xs: 2, sm: 2.5, md: 3 },
        }}
      >
        {t("bookDemoSection.formHeading")}
      </Typography>

      {/* Progress bar */}
      <Box sx={{ mb: { xs: 2.5, sm: 3 } }}>
        <Box
          sx={{
            width: "100%",
            height: "8px",
            backgroundColor: "#E5E7EB",
            borderRadius: "6px",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: meetingBooked
                ? "100%"
                : `${(Math.min(currentStep, 4) / 4) * 100}%`,
              height: "100%",
              backgroundColor: "#FFB200",
              transition: "width 0.3s ease",
            }}
          />
        </Box>
        <Typography
          sx={{
            fontFamily: "var(--font-outfit), sans-serif",
            fontSize: "0.7rem",
            color: "#9CA3AF",
            mt: 0.75,
            textAlign: isArabic ? "right" : "left",
            display: { xs: "block", sm: "none" },
          }}
        >
          {Math.min(currentStep, 4)} / 4
        </Typography>
      </Box>

      {/* ── FORM STEPS 1-4 ── */}
      {currentStep <= 4 && (
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            handleNext();
          }}
          sx={{ width: "100%" }}
        >
          {/* ── STEP 1: Open roles ── */}
          {currentStep === 1 && (
            <>
              {/* Friendly welcome intro — this used to sit on the old step 1
                  (name/email). Since open roles is now the true first step,
                  it belongs here instead. */}
              <Typography
                sx={{
                  fontWeight: "bold",
                  color: "#111827",
                  fontFamily: "var(--font-plusjakarta), sans-serif",
                  mb: 1,
                  fontSize: { xs: "1rem", sm: "1.2rem", md: "1.4rem" },
                  textAlign: isArabic ? "right" : "left",
                  lineHeight: 1.3,
                }}
              >
                {t("contactMain.step1.headline")}
              </Typography>
              <Typography
                sx={{
                  color: "#6B7280",
                  fontFamily: "var(--font-outfit), sans-serif",
                  mb: { xs: 2, sm: 3 },
                  fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("contactMain.step1.subheadline")}
              </Typography>

              <StepHeadline>
                {t("bookDemoSection.form.openRoles")}{" "}
                <Box component="span" sx={{ color: "#EF4444" }}>
                  *
                </Box>
              </StepHeadline>
              <Box sx={{ mb: 2 }}>
                {["1-5", "6-10", "11-25", "26-50", "50+"].map((opt) => (
                  <CheckOption
                    key={opt}
                    label={opt}
                    isArabic={isArabic}
                    checked={formData.openRoles === opt}
                    onChange={(e) => {
                      setFormData((p) => ({
                        ...p,
                        openRoles: e.target.checked ? opt : "",
                      }));
                      if (errors.openRoles)
                        setErrors((p) => ({ ...p, openRoles: "" }));
                    }}
                  />
                ))}
                {errors.openRoles && (
                  <Typography
                    sx={{
                      color: "#EF4444",
                      fontSize: "12px",
                      mt: 1,
                      textAlign: isArabic ? "right" : "left",
                    }}
                  >
                    {errors.openRoles}
                  </Typography>
                )}
              </Box>

              {/* reCAPTCHA v3 is invisible — no checkbox/widget is rendered.
                  Google requires disclosing that the site is protected by
                  reCAPTCHA when the badge itself isn't shown; keep this line
                  (or leave the default bottom-right badge visible) per their
                  ToS: https://developers.google.com/recaptcha/docs/faq */}
              <Typography
                sx={{
                  fontFamily: "var(--font-outfit), sans-serif",
                  fontSize: "0.7rem",
                  color: "#9CA3AF",
                  mb: 2,
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("bookDemoSection.form.recaptchaDisclosure", {
                  defaultValue:
                    "This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.",
                })}
              </Typography>
              {captchaError && (
                <Typography
                  sx={{
                    color: "#d32f2f",
                    fontSize: "12px",
                    mb: 2,
                    textAlign: isArabic ? "right" : "left",
                  }}
                >
                  {captchaError}
                </Typography>
              )}
            </>
          )}

          {/* ── STEP 2: What's slowing down your hiring? ── */}
          {currentStep === 2 && (
            <>
              <StepHeadline>
                {t("contactMain.step3.headline")}{" "}
                <Box component="span" sx={{ color: "#EF4444" }}>
                  *
                </Box>
              </StepHeadline>
              <Typography
                sx={{
                  color: "#6B7280",
                  fontFamily: "var(--font-outfit), sans-serif",
                  mb: { xs: 2, sm: 3 },
                  fontSize: {
                    xs: "0.8rem",
                    sm: "0.9rem",
                    md: "0.95rem",
                  },
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("contactMain.selectAll")}
              </Typography>
              <Box sx={{ mb: 2 }}>
                {[
                  t("contactMain.step3.opt1"),
                  t("contactMain.step3.opt2"),
                  t("contactMain.step3.opt3"),
                  t("contactMain.step3.opt4"),
                  "other",
                ].map((option) => (
                  <Box key={option} sx={{ mb: 1.5 }}>
                    <CheckOption
                      label={
                        option === "other"
                          ? t("contactMain.other")
                          : option
                      }
                      isArabic={isArabic}
                      checked={formData.hiringSlowdowns.includes(
                        option,
                      )}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "hiringSlowdowns",
                            value: option,
                            checked: e.target.checked,
                            type: "checkbox",
                          },
                        });
                      }}
                    />
                    {option === "other" && showHiringSlowdownsOther && (
                      <TextField
                        name="hiringSlowdownsOther"
                        value={formData.hiringSlowdownsOther}
                        onChange={handleChange}
                        placeholder={t("contactMain.pleaseSpecify")}
                        disabled={loading}
                        error={!!errors.hiringSlowdownsOther}
                        helperText={errors.hiringSlowdownsOther}
                        size="small"
                        sx={{
                          ...inputSx,
                          ml: { xs: 0, sm: isArabic ? 0 : 5 },
                          mr: { xs: 0, sm: isArabic ? 5 : 0 },
                          mt: 1,
                          width: {
                            xs: "100%",
                            sm: "calc(100% - 52px)",
                          },
                        }}
                        inputProps={{
                          style: {
                            textAlign: isArabic ? "right" : "left",
                          },
                        }}
                      />
                    )}
                  </Box>
                ))}
                {errors.hiringSlowdowns && (
                  <Typography
                    sx={{
                      color: "#EF4444",
                      fontSize: "12px",
                      mt: 1,
                      textAlign: isArabic ? "right" : "left",
                    }}
                  >
                    {errors.hiringSlowdowns}
                  </Typography>
                )}
              </Box>
            </>
          )}

          {/* ── STEP 3: First name + Email ── */}
          {currentStep === 3 && (
            <>
              <StepHeadline>
                {t("bookDemoSection.form.almostThere")}
              </StepHeadline>
              <Box sx={{ mb: 2 }}>
                <FieldLabel required isArabic={isArabic}>
                  {t("contactMain.step1.firstNameLabel")}
                </FieldLabel>
                <TextField
                  fullWidth
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder={t(
                    "contactMain.step1.firstNamePlaceholder",
                  )}
                  disabled={loading || emailVerifying}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  size="small"
                  sx={inputSx}
                  inputProps={{
                    style: { textAlign: isArabic ? "right" : "left" },
                  }}
                />
              </Box>

              <Box sx={{ mb: 2 }}>
                <FieldLabel required isArabic={isArabic}>
                  {t("contactMain.step1.emailLabel")}
                </FieldLabel>
                <TextField
                  fullWidth
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t("contactMain.step1.emailPlaceholder")}
                  disabled={loading || emailVerifying}
                  error={!!errors.email}
                  helperText={errors.email}
                  size="small"
                  FormHelperTextProps={{
                    sx: { mx: 0, mt: 1 },
                  }}
                  sx={inputSx}
                  inputProps={{
                    style: { textAlign: isArabic ? "right" : "left" },
                  }}
                />
              </Box>
            </>
          )}

          {/* ── STEP 4: Phone number + Company website + Company name ── */}
          {currentStep === 4 && (
            <>
              <StepHeadline>
                {t("contactMain.step2.headline", {
                  name:
                    formData.firstName || t("contactMain.step2.there"),
                })}
              </StepHeadline>
              <Typography
                sx={{
                  color: "#6B7280",
                  fontFamily: "var(--font-outfit), sans-serif",
                  mb: { xs: 2, sm: 3 },
                  fontSize: {
                    xs: "0.8rem",
                    sm: "0.9rem",
                    md: "0.95rem",
                  },
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {/* {t("contactMain.step2.subheadline")} */}
              </Typography>

              {/* Phone */}
              <Box sx={{ mb: 2 }}>
                <Box
                  component="span"
                  sx={{
                    fontFamily: "var(--font-outfit), sans-serif",
                    fontSize: { xs: "0.875rem", md: "1rem" },
                    fontWeight: 500,
                    color: "#374151",
                    mb: 0.5,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.25,
                    flexDirection: isArabic ? "row-reverse" : "row",
                  }}
                >
                  {t("contactMain.step2.phoneLabel")}{" "}
                  <Box component="span" sx={{ color: "#EF4444" }}>
                    *
                  </Box>
                  <Tooltip
                    title={t("contactMain.step2.phoneTooltip")}
                    placement="top"
                    arrow
                  >
                    <IconButton
                      size="small"
                      sx={{ p: 0.25, color: "#6B7280" }}
                      tabIndex={-1}
                    >
                      <InfoOutlinedIcon sx={{ fontSize: "1rem" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: 0.75, sm: 1 },
                    flexDirection: isArabic ? "row-reverse" : "row",
                  }}
                >
                  <FormControl
                    sx={{
                      width: { xs: 90, sm: 100, md: 110 },
                      minWidth: { xs: 90, sm: 100, md: 110 },
                      flexShrink: 0,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        bgcolor: "rgba(255,255,255,0.9)",
                        fontFamily: "var(--font-outfit), sans-serif",
                      },
                    }}
                  >
                    <Select
                      name="phoneCountryCode"
                      value={formData.phoneCountryCode || "+966"}
                      onChange={handleChange}
                      onClose={() => setCountrySearch("")}
                      disabled={loading}
                      displayEmpty
                      size="medium"
                      MenuProps={{
                        disableScrollLock: true,
                        autoFocus: false,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        PaperProps: {
                          sx: {
                            maxHeight: 320,
                            borderRadius: "10px",
                            ml: { xs: 0.25, sm: 0.5 }, // thora right shift
                            mt: 0.5,
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                            // ── Custom scrollbar styling ──
                            "&::-webkit-scrollbar": {
                              width: "6px",
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "#D1D5DB",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              backgroundColor: "#9CA3AF",
                            },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#D1D5DB transparent",
                          },
                        },
                      }}
                      sx={{
                        height: { xs: "40px", sm: "44px" },
                        "& .MuiSelect-select": {
                          py: 1.2,
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          flexDirection: isArabic
                            ? "row-reverse"
                            : "row",
                        },
                      }}
                    >
                      {/* ── Search box inside the dropdown ── */}
                      <Box
                        sx={{
                          position: "sticky",
                          top: 0,
                          bgcolor: "#fff",
                          zIndex: 1,
                          p: 1,
                          borderBottom: "1px solid #E5E7EB",
                        }}
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => e.stopPropagation()}
                      >
                        {/* ── Search box inside the dropdown ── */}
                        <TextField
                          autoFocus
                          fullWidth
                          size="small"
                          placeholder={isArabic ? "بحث عن الرمز..." : "Search code..."}
                          value={countrySearch}
                          onChange={(e) => {
                            // digits only — strip anything that isn't 0-9
                            const digitsOnly = e.target.value.replace(/\D/g, "");
                            setCountrySearch(digitsOnly);
                          }}
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              fontFamily: "var(--font-outfit), sans-serif",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "0.8rem",
                              py: 0.75,
                            },
                          }}
                        />
                      </Box>

                      {filteredCountryCodes.length === 0 && (
                        <MenuItem disabled>
                          {isArabic ? "لا توجد نتائج" : "No results"}
                        </MenuItem>
                      )}

                      {filteredCountryCodes.map(({ value, flag }) => (
                        <MenuItem
                          key={`${value}-${flag}`}   // was key={value} — not unique when codes repeat (+1, +7)
                          value={value}
                          sx={{
                            display: "flex",
                            flexDirection: isArabic ? "row-reverse" : "row",
                            gap: "6px",
                            fontSize: { xs: "0.8rem", sm: "0.875rem" },
                          }}
                        >
                          {isArabic ? (
                            <>
                              {toArabicNumerals(value)}
                              <span>{flag}</span>
                            </>
                          ) : (
                            <>
                              <span>{flag}</span>
                              {value}
                            </>
                          )}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder={t(
                      "contactMain.step2.phonePlaceholder",
                    )}
                    disabled={loading}
                    error={!!errors.phoneNumber}
                    helperText={errors.phoneNumber}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      maxLength: 15,
                      style: { textAlign: isArabic ? "right" : "left" },
                    }}
                    size="small"
                    sx={inputSx}
                  />
                </Box>
              </Box>

              {/* Company Website */}
              <Box sx={{ mb: 2 }}>
                <Box
                  component="span"
                  sx={{
                    fontFamily: "var(--font-outfit), sans-serif",
                    fontSize: { xs: "0.875rem", md: "1rem" },
                    fontWeight: 500,
                    color: "#374151",
                    mb: 0.5,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.25,
                    flexDirection: isArabic ? "row-reverse" : "row",
                  }}
                >
                  {t("contactMain.step2.websiteLabel")}{" "}
                  <Box component="span" sx={{ color: "#EF4444" }}>
                    *
                  </Box>
                  <Tooltip
                    title={t("contactMain.step2.websiteTooltip")}
                    placement="top"
                    arrow
                  >
                    <IconButton
                      size="small"
                      sx={{ p: 0.25, color: "#6B7280" }}
                      tabIndex={-1}
                    >
                      <InfoOutlinedIcon sx={{ fontSize: "1rem" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <TextField
                  fullWidth
                  name="companyWebsite"
                  value={formData.companyWebsite}
                  onChange={handleChange}
                  placeholder={t(
                    "contactMain.step2.websitePlaceholder",
                  )}
                  disabled={loading}
                  error={!!errors.companyWebsite}
                  helperText={errors.companyWebsite}
                  size="small"
                  sx={inputSx}
                  inputProps={{
                    style: { textAlign: isArabic ? "right" : "left" },
                  }}
                />
              </Box>

              {/* Company Name */}
              <Box sx={{ mb: 2 }}>
                <FieldLabel required isArabic={isArabic}>
                  {t("bookDemoSection.form.companyName")}
                </FieldLabel>
                <TextField
                  fullWidth
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder={t(
                    "bookDemoSection.form.companyNamePlaceholder",
                  )}
                  disabled={loading}
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  size="small"
                  sx={inputSx}
                  inputProps={{
                    style: { textAlign: isArabic ? "right" : "left" },
                  }}
                />
              </Box>
            </>
          )}

          {/* Verifying email message — shown on step 3 now (email field lives here) */}
          {currentStep === 3 && emailVerifying && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: isArabic ? "flex-end" : "flex-start",
                gap: 1,
                mt: 2,
                flexDirection: isArabic ? "row-reverse" : "row",
              }}
            >
              <CircularProgress size={14} sx={{ color: "#FFB200" }} />
              <Typography
                sx={{
                  fontFamily: "var(--font-outfit), sans-serif",
                  fontSize: {
                    xs: "0.75rem",
                    sm: "0.8rem",
                    md: "0.85rem",
                  },
                  color: "#6B7280",
                  textAlign: isArabic ? "right" : "left",
                }}
              >
                {t("bookDemoSection.form.verifyingEmail")}
              </Typography>
            </Box>
          )}
          {/* ── NAVIGATION BUTTONS ── */}
          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              mt: { xs: 2, sm: 3 },
              alignItems: "center",
              justifyContent: currentStep > 1 ? "flex-end" : "flex-end",
              flexDirection: isArabic ? "row-reverse" : "row",
            }}
          >
            {currentStep > 1 && (
              <Button
                onClick={handleBack}
                variant="text"
                sx={{
                  color: "#6B7280",
                  textTransform: "none",
                  fontFamily: "var(--font-outfit), sans-serif",
                  fontSize: {
                    xs: "0.8rem",
                    sm: "0.875rem",
                    md: "1rem",
                  },
                  fontWeight: 500,
                  px: { xs: 2, sm: 2.5, md: 3 },
                  py: { xs: 0.75, sm: 0.875, md: 1.125 },
                  minWidth: "auto",
                  transition: "all 0.3s ease-in-out",

                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#FFB200",
                    transform: "scale(1.05)",
                  },
                }}
              >
                {t("contactMain.back")}
              </Button>
            )}

            <Button
              id={currentStep === 4 ? "btn-eleven" : "btn-eight"}
              onClick={
                currentStep === 1
                  ? (e) => {
                    e.preventDefault();
                    handleNext();
                  }
                  : handleNext
              }
              disabled={loading || (currentStep === 3 && emailVerifying)}
              variant="contained"
              fullWidth={currentStep === 1}
              sx={{
                bgcolor: "#FFB200",
                fontFamily: "var(--font-outfit), sans-serif",
                py: { xs: 0.875, sm: 1, md: 1.125 },
                px: { xs: 3, sm: 3.5, md: 4 },
                borderRadius: "8px",
                textTransform: "none",
                fontSize: { xs: "0.8rem", sm: "0.875rem", md: "1rem" },
                fontWeight: 500,
                minWidth:
                  currentStep > 1
                    ? { xs: "100px", sm: "110px", md: "120px" }
                    : "100%",
                transition: "all 0.3s ease-in-out",

                boxShadow: "none",
                "&:hover": {
                  bgcolor: "#FFB200",
                  boxShadow: "0 2px 8px rgba(255,178,0,0.3)",
                  transform: "scale(1.05)",
                },
                "&:disabled": {
                  bgcolor: "#E5E7EB",
                  color: "#9CA3AF",
                  boxShadow: "none",
                },
              }}
            >
              {currentStep === 3 && emailVerifying ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <CircularProgress
                    size={16}
                    sx={{ color: "white" }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "var(--font-outfit), sans-serif",
                      fontSize: "0.8rem",
                      color: "white",
                    }}
                  >
                    {t("bookDemoSection.form.verifyingShort")}
                  </Typography>
                </Box>
              ) : loading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : currentStep === 4 ? (
                t("contactMain.continue")
              ) : (
                t("contactMain.next")
              )}
            </Button>
          </Box>



          {/* Disclaimer — shown on step 3 now (email field lives here) */}
          {currentStep === 3 && (
            <Typography
              sx={{
                fontFamily: "var(--font-outfit), sans-serif",
                fontSize: {
                  xs: "0.65rem",
                  sm: "0.7rem",
                  md: "0.72rem",
                },
                color: "#94a3b8",
                textAlign: "center",
                lineHeight: 1.5,
                mt: { xs: 1.5, sm: 2 },
                px: { xs: 1, sm: 0 },
              }}
            >
              {/* {t("bookDemoSection.form.disclaimer")} */}
            </Typography>
          )}
        </Box>
      )}

      {/* ── STEP 5: Google Calendar booking ── */}
      {currentStep === 5 && (
        <>
          {/* Thank you state after booking */}
          {meetingBooked ? (
            <Box
              sx={{
                py: { xs: 5, sm: 6, md: 8 },
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: { xs: "80px", sm: "100px", md: "120px" },
                  height: { xs: "80px", sm: "100px", md: "120px" },
                  borderRadius: "50%",
                  backgroundColor: "#D1FAE5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 3,
                  animation: "scaleIn 0.5s ease-out",
                  "@keyframes scaleIn": {
                    "0%": { transform: "scale(0)", opacity: 0 },
                    "50%": { transform: "scale(1.1)" },
                    "100%": { transform: "scale(1)", opacity: 1 },
                  },
                }}
              >
                <Box
                  component="svg"
                  viewBox="0 0 24 24"
                  sx={{
                    width: { xs: "50px", sm: "60px", md: "70px" },
                    height: { xs: "50px", sm: "60px", md: "70px" },
                    strokeWidth: 3,
                    stroke: "#10B981",
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                  }}
                >
                  <path d="M20 6L9 17l-5-5" />
                </Box>
              </Box>
              <Typography
                sx={{
                  fontFamily: "var(--font-plusjakarta), sans-serif",
                  fontSize: { xs: "1.2rem", sm: "1.6rem", md: "2rem" },
                  fontWeight: "bold",
                  color: "#111827",
                  mb: 2,
                }}
              >
                {t("contactMain.step9.thankYou", {
                  name: formData.firstName || "there",
                })}
              </Typography>
              {meetingDate && (
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit), sans-serif",
                    fontSize: {
                      xs: "1rem",
                      sm: "1.1rem",
                      md: "1.2rem",
                    },
                    color: "#111827",
                    fontWeight: 600,
                    mb: 1.5,
                  }}
                >
                  {new Date(meetingDate).toLocaleDateString(undefined, {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                  {" at "}
                  {new Date(meetingDate).toLocaleTimeString(undefined, {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </Typography>
              )}
              <Typography
                sx={{
                  fontFamily: "var(--font-outfit), sans-serif",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  color: "#4B5563",
                  lineHeight: 1.6,
                }}
              >
                {t("contactMain.step9.confirmation")}
              </Typography>
            </Box>
          ) : (
            // Placeholder while modal is open
            <Box sx={{ minHeight: 200 }} />
          )}

          {/*
            ── Booking Modal ──
            IMPORTANT: only the "active" slot (the one matching formModalOpen)
            is allowed to render GoogleSlotPicker. Both the inline card and
            the popup card share the same component state, so this guard
            guarantees exactly one booking widget instance exists in the DOM
            at once.
          */}
          {!meetingBooked && isPopup === formModalOpen && (
            <Modal
              open={currentStep === 5 && !meetingBooked}
              onClose={() => setShowPickSlotHint(true)}
              disableEscapeKeyDown
              disableAutoFocus
              hideBackdrop={false}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 1, sm: 2 },
                "& .MuiBackdrop-root": {
                  backgroundColor: "rgba(0,0,0,0.5)",
                  backdropFilter: "blur(6px)",
                },
              }}
              slotProps={{
                backdrop: {
                  sx: { cursor: "pointer" },
                  onClick: () => setShowPickSlotHint(true),
                },
              }}
            >
              <Box
                onClick={() => setShowPickSlotHint(false)}
                sx={{
                  width: "100%",
                  maxWidth: { xs: "100%", sm: "95%", md: 1100 },
                  height: { xs: "90vh", sm: "85vh", md: "80vh" },
                  bgcolor: "white",
                  borderRadius: "12px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "default",
                  position: "relative",
                }}
              >
                {/* ── "Pick a slot" hint banner ──
                    Lives INSIDE this Modal's own box (not a portal-based
                    Snackbar), so it is guaranteed to render above this
                    Modal's own content and can never end up hidden behind
                    another modal's blurred backdrop when this Modal is
                    nested inside the outer popup Modal. */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 12,
                    left: "50%",
                    transform: showPickSlotHint
                      ? "translateX(-50%) translateY(0)"
                      : "translateX(-50%) translateY(-14px)",
                    opacity: showPickSlotHint ? 1 : 0,
                    pointerEvents: "none",
                    transition: "opacity 0.25s ease, transform 0.25s ease",
                    zIndex: 5,
                    bgcolor: "white",
                    borderLeft: "4px solid #FFB200",
                    borderRadius: "8px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
                    px: 2.5,
                    py: 1.5,
                    whiteSpace: "nowrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "var(--font-outfit), sans-serif",
                      fontSize: "0.9375rem",
                      color: "#FFB200",
                      fontWeight: 600,
                    }}
                  >
                    {t("contactMain.step9.pickSlot")}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    border: showPickSlotHint
                      ? "3px solid #FFB200"
                      : "3px solid transparent",
                    borderRadius: "8px",
                    transition: "border-color 0.2s ease",
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ flex: 1, minHeight: 0, width: "100%", height: "100%" }}>
                    <GoogleSlotPicker
                      recruiterEmail={RECRUITER_EMAIL}
                      candidateName={formData.firstName}
                      candidateEmail={formData.email}
                      submissionId={submissionId}
                      recruiterName="Abdul Hannan"
                      onBooked={({ startTime, endTime }) => {
                        setMeetingDate(startTime);
                        setMeetingTime(endTime);
                        setMeetingBooked(true);

                        pushBookingConfirmed();

                        // NOTE: confirmation email + Slack + Mongo update /api/google/book
                        // ke andar already ho chuke hain — dobara call karne ki zaroorat nahi.
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Modal>
          )}
        </>
      )}
    </Box>
  );

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <GoogleCaptchaWrapper>
      <Box
        id="book-demo-section"
        sx={{
          backgroundColor: "#fff",
          py: { xs: 5, sm: 6, md: 8 },
          direction: isArabic ? "rtl" : "ltr",
        }}
      >
        <Snackbar
          open={showToast}
          autoHideDuration={3000}
          onClose={(_, r) => r !== "clickaway" && setShowToast(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            severity={submitMessage.type}
            sx={{ width: "100%", fontFamily: "var(--font-outfit), sans-serif" }}
          >
            {submitMessage.text}
          </Alert>
        </Snackbar>

        <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 8 } }}>
          {/* ── HEADING ── */}
          <Box sx={{ textAlign: "center", mb: { xs: 4, sm: 5, md: 10 } }}>
            <Typography
              component="h2"
              sx={{
                fontFamily: "var(--font-plusjakarta), sans-serif",
                fontWeight: 800,
                fontSize: { xs: "1.6rem", sm: "2.2rem", md: "3.2rem" },
                color: "#0f172a",
                lineHeight: 1.2,
                letterSpacing: "-0.02em",
                maxWidth: 880,
                mx: "auto",
                px: { xs: 1, sm: 0 },
              }}
            >
              {t("bookDemoSection.heading")}
            </Typography>
          </Box>

          {/* ── TWO COLUMN LAYOUT ── */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "1.1fr 0.9fr" },
              gap: { xs: 4, sm: 5, md: 8 },
              alignItems: "start",
            }}
          >
            {/* ── LEFT COLUMN ── */}
            <Box sx={{ pr: { md: 4 } }}>
              <Typography
                sx={{
                  fontFamily: "var(--font-plusjakarta), sans-serif",
                  fontWeight: 800,
                  fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
                  color: "#0f172a",
                  mb: { xs: 2.5, sm: 3, md: 3.5 },
                }}
              >
                {t("bookDemoSection.leftHeading")}
              </Typography>

              {/* Check items */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 1.5, sm: 2, md: 2.5 },
                  mb: { xs: 3.5, sm: 4, md: 5 },
                }}
              >
                {checkItems.map((key) => (
                  <Box
                    key={key}
                    sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}
                  >
                    <Box
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        backgroundColor: "#e6f7ed",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        mt: "2px",
                      }}
                    >
                      <CheckIcon
                        sx={{ fontSize: "0.85rem", color: "#10b981" }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: "var(--font-outfit), sans-serif",
                        fontSize: {
                          xs: "0.85rem",
                          sm: "0.9rem",
                          md: "0.92rem",
                        },
                        color: "#475569",
                        lineHeight: 1.5,
                      }}
                    >
                      {t(key)}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Stats row */}
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 1.5, sm: 2 },
                  mb: { xs: 3.5, sm: 4, md: 5 },
                  flexWrap: "wrap",
                }}
              >
                {stats.map((s, i) => (
                  <Box
                    key={i}
                    sx={{
                      backgroundColor: "#FCFAFF",
                      borderRadius: "8px",
                      p: { xs: 2, sm: 2.5 },
                      minWidth: { xs: "80px", sm: "100px", md: "120px" },
                      flex: "1 1 0px",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "var(--font-outfit), sans-serif",
                        fontWeight: 800,
                        fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.5rem" },
                        color: "#8736FF",
                        lineHeight: 1,
                        mb: 0.75,
                      }}
                    >
                      {t(s.valueKey)}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "var(--font-outfit), sans-serif",
                        fontSize: {
                          xs: "0.65rem",
                          sm: "0.72rem",
                          md: "0.75rem",
                        },
                        fontWeight: 400,
                        color: "#4B5563",
                        lineHeight: 1.3,
                      }}
                    >
                      {t(s.labelKey)}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Accent note box */}
              <Box
                sx={{
                  border: "1px solid #FFB200",
                  borderRadius: "8px",
                  p: { xs: 2, sm: 2.5, md: 3 },
                  backgroundColor: "#FFFCF5",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit), sans-serif",
                    fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem" },
                    color: "#1e293b",
                    lineHeight: 1.6,
                  }}
                >
                  {t("bookDemoSection.noteLine1")}{" "}
                  <Box component="span" sx={{ fontWeight: 800 }}>
                    {t("bookDemoSection.noteHighlight")}
                  </Box>{" "}
                  {t("bookDemoSection.noteNotSales")}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit), sans-serif",
                    fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem" },
                    color: "#364153",
                    lineHeight: 1.6,
                    mt: 1,
                  }}
                >
                  {t("bookDemoSection.noteLine2")}
                </Typography>
              </Box>
            </Box>

            {/* ── RIGHT COLUMN — MULTI-STEP FORM (inline slot) ── */}
            {renderFormCard(false)}
          </Box>
        </Container>
      </Box>

      {/* ── POPUP MODAL — opened instantly (no scroll) from the navbar "Book Demo" button ── */}
      <Modal
        open={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        disableScrollLock
        disableAutoFocus
        disableEnforceFocus
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 1, sm: 2 },
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(6px)",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: { xs: "100%", sm: 560, md: 640 },
            maxHeight: "90vh",
            overflowY: "auto",
            bgcolor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            p: { xs: 2, sm: 3 },
          }}
        >
          <IconButton
            onClick={() => setFormModalOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              ...(isArabic ? { left: 8 } : { right: 8 }),
              color: "#6B7280",
              zIndex: 1,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          {/* ── Popup slot ── */}
          {renderFormCard(true)}
        </Box>
      </Modal>
    </GoogleCaptchaWrapper>
  );
};

export default BookDemoSection;